module.exports = __webpack_public_path__ + "img/circle_red_center.2a41796d.png";